import ai from '../assets/icons/AI.png'
import agnostic from '../assets/icons/app-agnostic.png'
import risk from '../assets/icons/rish-free.png'

const data = [
    {
        img:   ai ,
        title:'AI-Powered',
        para: 'Integrated solution including process Discovery, RPA and Analytics'
    },
    {
        img:   agnostic ,
        title:'Application agnostic',
        para: 'RPA integrates across platforms and fits in any business process'
    },
    {
        img:   risk ,
        title:'Risk-free',
        para: 'With top data security measures, RPA protects business interest and customer information'
    },
]


export default data;